import { Text, Flex } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { FormikProps } from 'formik';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

type PrincipalBalancePointInTimeConfigProps = {
  formProps: FormikProps<CreditAgreement.Config.CommonPostgresQuery.Query.PrincipalBalancePointInTimeQuery>;
};
export const PrincipalBalancePointInTimeConfig = ({
  formProps,
}: PrincipalBalancePointInTimeConfigProps) => {
  return (
    <Flex flexDir="column">
      <Flex mb="3">
        <Text>Date Formula:</Text>
        <Editor
          value={formProps.values.parameterConfig.dateFormula.formula}
          onChange={(val) =>
            formProps.setFieldValue('parameterConfig.dateFormula.formula', val)
          }
          width="100%"
          theme="vs-dark"
          height="15vh"
        />
      </Flex>
    </Flex>
  );
};
